import { render } from "./ForgetPassword.vue?vue&type=template&id=e2cc4b8a"
import script from "./ForgetPassword.vue?vue&type=script&lang=js"
export * from "./ForgetPassword.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/khatoncollection-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__